<template>
  <a-card :bordered="false">
    <!-- <a-form layout="inline" onSubmit="">
        <a-form-item label="活动界次">
          <j-dict-select-tag
            :defaultShowAll="true"
            type="radioButton"
            v-model="queryParam.eventId"
            :trigger-change="true"
            dictCode="event_orders"
            placeholder="请选择活动"
          />
        </a-form-item>
      </a-form>
      <a-divider /> -->
    <a-list :dataSource="cmsDataSource">
      <a-list
        item-layout="vertical"
        size="large"
        :pagination="pagination"
        :data-source="cmsDataSource"
      >
        <div slot="footer">共{{ info.total }}篇</div>
        <a-list-item slot="renderItem" key="item.title" slot-scope="item">
          <a-list-item-meta :description="item.description">
            <a slot="title" @click="toDetail(item)"
              ><h3 class="title">{{ item.cmsTitile }}</h3></a
            >
          </a-list-item-meta>
          <p v-if="item.cmsDesc">
            {{ item.cmsDesc }}
          </p>
          <div class="cms-info">
            <a-icon type="clock-circle" />
            <span class="gap">{{ item.createTime }}</span>
          </div>
        </a-list-item>
      </a-list>
    </a-list>
  </a-card>
</template>

<script>
import { getAction } from "@/api/manage";
import JDictSelectTag from "@/components/jeecg/JDictSelectTag";

export default {
  components: {
    JDictSelectTag,
  },
  data() {
    return {
      info: {},
      cmsDataSource: [],
      pagination: {
        onChange: (page) => {
          console.log(page);
        },
        pageSize: 10,
      },
      queryParam: {
        cmsType: "",
      },
    };
  },
  created() {
    let type = "";
    if (this.$route.query.type) {
      type = this.$route.query.type;
    }
    this.getCmsList(type);
  },
  watch:{
    $route(v){
      this.getCmsList(this.$route.query.type);
    }
  },
  methods: {
    getCmsList(type) {
      this.cmsDataSource = [];
      getAction("/teaching/teachingCms/getCmsList", {
        cmsStatus: 1,
        cmsType: type,
        pageSize: 999,
      }).then((res) => {
        if (res.success) {
          this.info = res.result;
          this.cmsDataSource = res.result.records;
        }
      });
    },
    toDetail(item) {
      let route = this.$router.resolve({
        path: "/cms/detail",
        query: {
          id: item.id,
        },
      });
      window.open(route.href, '_blank');
    },
    handleChangeType(v) {},
  },
};
</script>

<style lang="less" scoped>
.gap {
  margin-left: 5px;
  margin-right: 20px;
  font-size: 14px;
}
.title {
  font-weight: 700;
}
/deep/.title:hover {
  color: #1890ff;
}
</style>